module.exports = __webpack_public_path__ + "img/colored_horizontal-bar-icon-21022022.5d744480.svg";